import {Navigation} from "./navigation";
import {GallerySwiper} from "./gallery-swiper";
import {Overlay} from "./overlay";
import {Preview} from "./preview";
import {Counter} from "./counter";

export class Gallery {

    constructor(parent) {
        this.parent = parent;
        this.wrapper = this.parent.querySelector('.gallery__swiper-wrapper')

        this.wrapper.addEventListener('click', event => event.stopPropagation());

        this.navigation = new Navigation(
            parent.querySelector('.gallery__nav'),
            this
        );

        this.swiper = new GallerySwiper(
            parent.querySelector('.gallery__swiper'),
            this
        );

        this.counter = new Counter(
            this.wrapper,
            this.navigation
        );

        new Preview(
            parent.querySelector('.gallery__preview'),
            new Overlay(
                parent.querySelector('.gallery__overlay'),
                this
            )
        );
    }


    changeSlide(index) {
        this.swiper.slideTo(index);
        this.navigation.slideTo(index);
        this.counter.setCurrentSlide(index);
    }

    init() {
        this.swiper.init();
        this.navigation.init();
    }


}


export function GalleryInit() {
    const galleries = [...document.querySelectorAll('.gallery')];
    galleries.forEach(gallery => new Gallery(gallery));
}
